import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import WashInstructions from '~/components/blocks/acf/WashInstructions';

const WashInstructionsBlock = ({
    attributes,
    globalBlockOptions,
    blockWashInstructions: { title, subtitle = '', description = '', steps }
}) => (
    <WashInstructions
        {...{
            attributes,
            globalBlockOptions,
            title,
            subtitle,
            description,
            steps
        }}
    />
);

WashInstructionsBlock.propTypes = {
    blockWashInstructions: PropTypes.shape({
        blockWashInstructions: PropTypes.shape({
            title: PropTypes.string.isRequired,
            subtitle: PropTypes.string,
            description: PropTypes.string,
            steps: PropTypes.arrayOf(
                PropTypes.shape({
                    title: PropTypes.string.isRequired,
                    description: PropTypes.string.isRequired,
                    image: PropTypes.shape({
                        altText: PropTypes.string.isRequired,
                        sourceUrl: PropTypes.string.isRequired,
                        localFile: PropTypes.shape({
                            childImageSharp: PropTypes.shape({
                                gatsbyImageData: PropTypes.object.isRequired
                            })
                        })
                    }).isRequired
                })
            ).isRequired
        })
    }).isRequired
};

export default WashInstructionsBlock;

export const query = graphql`
    fragment WashInstructionsBlockFragment on WpAcfWashInstructionsBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockWashInstructions {
            title
            subtitle
            description
            steps {
                title
                description
                image {
                    id
                    altText
                    sourceUrl
                    localFile {
                        childImageSharp {
                            gatsbyImageData(aspectRatio: 1.75)
                        }
                    }
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Wash Instructions',
        description:
            'Title and Steps required. Recommended Image Size: 1.5 Aspect Ratio, Minimum 710px x 475px.',
        props: {
            name: 'acf/wash-instructions',
            blockWashInstructions: {
                title: 'Wash Instructions Title',
                subtitle: 'Subtitle lorem ipsum dolor sit amit!',
                description:
                    'Description lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                steps: [
                    {
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                        title: 'Step 1',
                        image: {
                            sourceUrl: 'https://picsum.photos/710/475?random=1',
                            altText: '',
                            id: '1'
                        }
                    },
                    {
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
                        title: 'Step 2',
                        image: {
                            sourceUrl: 'https://picsum.photos/710/475?random=2',
                            altText: '',
                            id: '2'
                        }
                    },
                    {
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        title: 'Prewash Area',
                        image: {
                            sourceUrl: 'https://picsum.photos/710/475?random=3',
                            altText: '',
                            id: '3'
                        }
                    },
                    {
                        description: 'Lorem ipsum dolor sit amet',
                        title: 'Lorem Ipsum',
                        image: {
                            sourceUrl: 'https://picsum.photos/710/475?random=4',
                            altText: '',
                            id: '4'
                        }
                    }
                ]
            }
        }
    }
];
